import { css } from 'styled-components'

export const fonts = css`
	@font-face {
		font-family: 'SBSansInterface';
		src: url('/fonts/SBSansInterface/SBSansInterface-Regular.woff2') format('woff2'),
		url('/fonts/SBSansInterface/SBSansInterface-Regular.woff') format('woff'),
		url('/fonts/SBSansInterface/SBSansInterface-Regular.eot') format('opentype'),
		url('/fonts/SBSansInterface/SBSansInterface-Regular.ttf') format('opentype');
		font-weight: 400;
	}
	@font-face {
		font-family: 'SBSansInterface';
		src: url('/fonts/SBSansInterface/SBSansInterface-Semibold.woff2') format('woff2'),
		url('/fonts/SBSansInterface/SBSansInterface-Semibold.woff') format('woff'),
		url('/fonts/SBSansInterface/SBSansInterface-Semibold.eot') format('opentype'),
		url('/fonts/SBSansInterface/SBSansInterface-Semibold.ttf') format('opentype');
		font-weight: 600;
	}
	@font-face {
		font-family: 'SBSansDisplay';
		src: url('/fonts/SBSansDisplay/SBSansDisplay-Regular.woff2') format('woff2'),
		url('/fonts/SBSansDisplay/SBSansDisplay-Regular.woff') format('woff'),
		url('/fonts/SBSansDisplay/SBSansDisplay-Regular.eot') format('opentype'),
		url('/fonts/SBSansDisplay/SBSansDisplay-Regular.ttf') format('opentype');
		font-weight: 400;
	}
	@font-face {
		font-family: 'SBSansDisplay';
		src: url('/fonts/SBSansDisplay/SBSansDisplay-SemiBold.woff2') format('woff2'),
		url('/fonts/SBSansDisplay/SBSansDisplay-SemiBold.woff') format('woff'),
		url('/fonts/SBSansDisplay/SBSansDisplay-SemiBold.eot') format('opentype'),
		url('/fonts/SBSansDisplay/SBSansDisplay-SemiBold.ttf') format('opentype');
		font-weight: 600;
	}
	@font-face {
		font-family: 'SBSansText';
		src: url('/fonts/SBSansText/SBSansText-Regular.woff2') format('woff2'),
		url('/fonts/SBSansText/SBSansText-Regular.woff') format('woff'),
		url('/fonts/SBSansText/SBSansText-Regular.eot') format('opentype'),
		url('/fonts/SBSansText/SBSansText-Regular.ttf') format('opentype');
		font-weight: 400;
	}
	@font-face {
		font-family: 'SBSansText';
		src: url('/fonts/SBSansText/SBSansText-Semibold.woff2') format('woff2');,
		url('/fonts/SBSansText/SBSansText-Semibold.woff') format('woff'),
		url('/fonts/SBSansText/SBSansText-Semibold.eot') format('opentype'),
		url('/fonts/SBSansText/SBSansText-Semibold.ttf') format('opentype');
		font-weight: 600;
	}
`
